// extracted by mini-css-extract-plugin
module.exports = {"compare-toggle":"CompareToggle_compare-toggle__L2t94","compare-toggle__active":"CompareToggle_compare-toggle__active__Pli88"};